module.exports = __webpack_public_path__ + "img/202408_03.95b0df7b.jpg";